import React from "react";
import { useSelector } from "react-redux";
import ClientInbox from "./components/client-inbox/ClientInbox";
import EmployeeInbox from "./components/employee-inbox/EmployeeInbox";

const Inbox = () => {

    const user = useSelector((state) => state.auth.user);

    return (
        <div>
            {(user?.user_level === 4) 
                ? <ClientInbox /> 
                : <EmployeeInbox />
            }
        </div>
    )
};
export default Inbox;